/**
 * Mirrors info_form.vue's setClickId(): copy a stored Google Click ID into the hidden
 * gcl_id field, if one was captured on an earlier page view.
 */
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    const gclid = window.localStorage.getItem('gclid')
    if (gclid) this.element.value = gclid
  }
}
